import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWideHalfRemove"><Path d="M2 4V20H12V18H4V13H22V4H2Z" fill="currentColor"/><Path d="M17 15.5858L15.5858 17L17.5858 19L15.5858 21L17 22.4142L19 20.4142L21 22.4142L22.4142 21L20.4142 19L22.4142 17L21 15.5858L19 17.5858L17 15.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalfRemove;
